import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Delivery Module Service Stores
 * Services for delivery tickets and routes management
 */
export const deliveryStores: ServiceStoreConfig[] = [
  {
    name: "delivery-tickets",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      serviceView: {
        enableServiceView: false,
        summaryCards: (rootStore) => {
          const store = rootStore.deliveryTicketsStore as {
            entities?: unknown[];
          };
          const entities = store?.entities || [];
          const totalTickets = entities.length;
          const todayTickets = entities.filter(
            (ticket: Record<string, unknown>) => {
              const ticketDate = new Date(ticket.createdAt as string);
              const today = new Date();
              today.setHours(0, 0, 0, 0);
              return ticketDate >= today;
            }
          ).length;
          const deliveredTickets = entities.filter(
            (ticket: Record<string, unknown>) =>
              ticket.status === "delivered" || ticket.status === "completed"
          ).length;
          const inTransitTickets = entities.filter(
            (ticket: Record<string, unknown>) =>
              ticket.status === "in_transit" || ticket.status === "dispatched"
          ).length;

          return [
            {
              title: "Total Tickets",
              value: () => totalTickets.toString(),
              valueColor: "primary.main",
              variant: "with-icon" as const,
            },
            {
              title: "Today",
              value: () => todayTickets.toString(),
              valueColor: "info.main",
            },
            {
              title: "Delivered",
              value: () => deliveredTickets.toString(),
              valueColor: "success.main",
            },
            {
              title: "In Transit",
              value: () => inTransitTickets.toString(),
              valueColor: "warning.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
        defaultSort: {
          sortBy: ["createdAt"],
          sortDirection: { createdAt: "DESC" },
        },
      },
    },
  },
  {
    name: "routes",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      serviceView: {
        enableServiceView: false,
        summaryCards: (rootStore) => {
          const store = rootStore.routesStore as {
            entities?: unknown[];
          };
          const entities = store?.entities || [];
          const totalRoutes = entities.length;
          const activeRoutes = entities.filter(
            (route: Record<string, unknown>) =>
              route.status === "active" || route.status === "in_progress"
          ).length;
          const completedRoutes = entities.filter(
            (route: Record<string, unknown>) =>
              route.status === "completed"
          ).length;
          const optimizedRoutes = entities.filter(
            (route: Record<string, unknown>) =>
              route.isOptimized === true
          ).length;

          return [
            {
              title: "Total Routes",
              value: () => totalRoutes.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Active",
              value: () => activeRoutes.toString(),
              valueColor: "warning.main",
            },
            {
              title: "Completed",
              value: () => completedRoutes.toString(),
              valueColor: "success.main",
            },
            {
              title: "Optimized",
              value: () => optimizedRoutes.toString(),
              valueColor: "info.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
        defaultSort: {
          sortBy: ["startTime"],
          sortDirection: { startTime: "ASC" },
        },
        actions: {
          onRowClick: (row) => {
            console.log("View route:", row.routeId);
          },
        },
      },
    },
  },
];